module.exports = "<div>\n    <nav class=\"navbar navbar-inner navbar-default navbar-static-top\" role=\"navigation\">\n        <div class=\"container-fluid\" ng-transclude=\"header\">\n        </div>\n    </nav>\n\n    <div class=\"container-fluid\" ng-transclude=\"body\"></div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/shared/page.html
// module id = 500
// module chunks = 0